<template>
    <themed-modal
        name="edit-proposal-expense-escalations"
        title="Edit Escalations"
        size="lg"
        :show-footer="true"
        @opened="populateEscalations">
        
        <div v-if="selectedProposalExpense" class="proposal-escalations-modal__toolbar">
            <p class="proposal-escalations-modal__expense-name">{{ selectedProposalExpense.type.name }}</p>
        </div>

        <div v-if="selectedProposalExpense && selectedProposal" class="proposal-escalations-modal__content  px-3">
            <div class="proposal-escalations-modal__table-wrapper">
                <table id="escalations" class="proposal-escalations-modal__table ">
                    <thead>
                        <tr>
                            <th class="proposal-escalations-modal__th">Year</th>
                            <th v-for="year in selectedProposal.term" :key="year" class="proposal-escalations-modal__th proposal-escalations-modal__th--center">
                                {{ year }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="proposal-escalations-modal__td"></td>
                            <td v-for="year in selectedProposal.term" :key="year" class="proposal-escalations-modal__td">
                                <div class="proposal-escalations-modal__input-group">
                                    <input
                                        @input="setEscalation($event)"
                                        @blur="setPreviousEscalationInput($event)"
                                        :data-year="year"
                                        data-month="1"
                                        type="text"
                                        class="proposal-escalations-modal__input"
                                    />
                                    <themed-button
                                        v-if="year != selectedProposal.term"
                                        variant="ghost"
                                        size="icon"
                                        @click="escalateAcross"
                                        class="proposal-escalations-modal__escalate-btn"
                                        aria-label="Escalate across remaining years">
                                        <theme-icon icon="chevron-right" type="icons" />
                                    </themed-button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <template #footer>
            <themed-button variant="secondary" @click="$modal.hide('edit-proposal-expense-escalations')">
                Close
            </themed-button>
            <themed-button variant="default" @click="saveExpense" :disabled="loading">
                <span v-if="loading">Saving...</span>
                <span v-else>Save Escalations</span>
            </themed-button>
        </template>
    </themed-modal>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import ThemedModal from '../ThemedModal.vue';
    
    export default {
        name: 'EditProposalExpenseEscalationsV1',

        components: {
            ThemedModal
        },

        data() {
            return { 
                loading: false,
                previousEscalationInput: null
            }
        },

        computed: {
            ...mapState(['projects']),
            ...mapState(['proposals']),
            ...mapGetters(['selectedProposal']),
            ...mapGetters(['selectedProposalExpense']),

            errors() {
                return this.proposals.errors;
            }
        },

        methods: {
            populateEscalations() {
                // Populate input values when modal opens
                this.$nextTick(() => {
                    if (this.selectedProposalExpense && this.selectedProposalExpense.escalations) {
                        this.selectedProposalExpense.escalations.forEach(escalation => {
                            let input = document.querySelector(`input[data-year='${escalation.year_number}']`);

                            if (input) {
                                input.value = escalation.amount;
                            }
                        });
                    }
                });
            },
            setEscalation(event) {
                let year = parseInt(event.target.dataset.year);
                let month = parseInt(event.target.dataset.month);
                
                let escalationRecord = _.find(this.selectedProposalExpense.escalations, (row) => {
                    return row.year_number == year && row.month_number == month
                });

                if (escalationRecord) {
                    escalationRecord.amount = event.target.value;
                } else {
                    this.selectedProposalExpense.escalations.push({
                        expense_id: this.selectedProposalExpense.id,
                        year_number: year,
                        month_number: month,
                        amount: event.target.value
                    });
                }
            },

            setPreviousEscalationInput(event) {
                this.previousEscalationInput = event.target;
            },

            escalateAcross() {
                if (! this.previousEscalationInput) {
                    return;
                }

                let year = parseInt(this.previousEscalationInput.dataset.year);
                let inputs = document.querySelectorAll(`#escalations input`);

                for (var i = 0; i < inputs.length; ++i) {
                    if (parseInt(inputs[i].dataset.year) > year) {
                        inputs[i].value = this.previousEscalationInput.value;

                        inputs[i].dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            },

            async saveExpense() {
                this.loading = true;

                await this.$store.dispatch('saveExpense').then(() => {
                    this.loading = false;

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: "Escalations Saved"
                    });

                    this.$emit('save-proposal');

                    this.$modal.hide('edit-proposal-expense-escalations');
                });
            }
        }
    }
</script>
